<template>
  <div class="profileupdate">
    <div class="col">
            <div class="row align-item-center pt-2 pb-2">
                <div class="col">
                    <h2 v-if="id" class="ui text huge-lg big-sm large black mb-0">{{$t('UpdateAddress')}}</h2>
                    <h2 v-else class="ui text huge-lg big-sm large black mb-0">{{$t('AddAddress')}}</h2>
                </div>
            </div>
            <hr class="gray-7 mt-0">
            <form>
                <div class="ui form">
                    <div class="row mt-lg-2 mt-3 mb-2 align-items-center">
                        <div class="col-12 col-lg-3 text-lg-right">
                            <label class="ui text medium-sm small color black">{{$t('Name')}}<span class="color theme">*</span></label></div>
                        <div class="col-12 col-lg-6">
                            <input class="ui text input medium-sm small" type="text" placeholder v-model="address.fullname"></div>
                    </div>
                    <div class="row mt-lg-2 mt-3 mb-2 align-items-center">
                        <div class="col-12 col-lg-3 text-lg-right"><label class="ui text medium-sm small color black">{{$t('Address')}}<span class="color theme">*</span></label>
                    </div>
                        <div class="col-12 col-lg-6">
                            <input class="ui text input medium-sm small" type="text" placeholder v-model="address.address">
                        </div>
                    </div>
                    <div class="row mt-lg-2 mt-3 mb-2 align-items-center">
                        <div class="col-12 col-lg-3 text-lg-right"><label class="ui text medium-sm small color black">{{$t('Street')}}<span class="color theme">*</span></label></div>
                        <div class="col-12 col-lg-6"><input class="ui text input medium-sm small" type="text" placeholder v-model="address.street"></div>
                    </div>
                    <div class="row mt-lg-2 mt-3 mb-2 align-items-center">
                        <div class="col-12 col-lg-3 text-lg-right"><label class="ui text medium-sm small color black">{{$t('Province')}}<span class="color theme">*</span></label></div>
                        <div class="col-12 col-lg-6">
                            <select class="ui input text medium-sm small  custom-select col-12"
                                @change="getAmphur" 
                                v-model="address.province_id">
                                <option  :value="null" disabled>{{$t('SelectProvince')}}</option>
                                <option v-for="province in provinces"
                                    :value="province.id"
                                    :selected="province.id == address.province_id">{{province.name_in_thai}}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="row mt-lg-2 mt-3 mb-2 align-items-center">
                        <div class="col-12 col-lg-3 text-lg-right"><label class="ui text medium-sm small color black">{{$t('Amphur')}}<span class="color theme">*</span></label></div>
                        <div class="col-12 col-lg-6">
                            <select class="ui input text medium-sm small  custom-select col-12"
                                @change="getDistrict"
                                v-model="address.amphur_id">
                                <option  :value="null" disabled>{{$t('SelectAmphur')}}</option>
                                <option v-for="amphur in amphurs" 
                                    :value="amphur.id"
                                    :selected="amphur.id == address.amphur_id">{{amphur.name_in_thai}}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="row mt-lg-2 mt-3 mb-2 align-items-center">
                        <div class="col-12 col-lg-3 text-lg-right">
                            <label class="ui text medium-sm small color black">{{$t('District')}}<span class="color theme">*</span></label></div>
                        <div class="col-12 col-lg-6">
                            <select class="ui input text medium-sm small ui  custom-select col-12"
                                v-model="address.district_id">
                                <option  :value="null" disabled>{{$t('SelectDistrict')}}</option>
                                <option v-for="district in districts" 
                                    :value="district.id"
                                    :selected="district.id == address.district_id">{{district.name_in_thai}}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="row mt-lg-2 mt-3 mb-2 align-items-center">
                        <div class="col-12 col-lg-3 text-lg-right"><label class="ui text medium-sm small color black">{{$t('PostCode')}}<span class="color theme">*</span></label></div>
                        <div class="col-12 col-lg-6"><input class="ui text input medium-sm small" type="text" placeholder v-model="address.zipcode"></div>
                    </div>
                    <div class="row mt-lg-2 mt-3 mb-2 align-items-center">
                        <div class="col-12 col-lg-3 text-lg-right"><label class="ui text medium-sm small color black">{{$t('Mobile')}}<span class="color theme">*</span></label></div>
                        <div class="col-12 col-lg-6"><input class="ui text input medium-sm small" type="text" placeholder v-model="address.phone"></div>
                    </div>
                    <div class="row mt-lg-2 mt-3 mb-2 align-items-center">
                        <div class="col-12 col-lg-3 text-lg-right"><label class="ui text medium-sm small color black"></label></div>
                        <div class="col-12 col-lg-6">
                            <div class="row">
                                <div class="col">
                                    <button @click.prevent="updateAddress" class="ui button theme text large col-12 py-2"><span class="ui text large">{{$t('Save')}}</span></button></div>
                                <div class="col">
                                    <router-link to="/profile" exact  class="ui button grey text large col-12 py-2"><span class="ui text large">{{$t('Cancel')}}</span>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
  </div>
</template>
<script>
import axios from "@/api/axios";
export default {
    name: 'addressEdit',
    data(){
        return {
            address : {
                fullname: '',
                address: '',
                street: '',
                province_id: null,
                amphur_id: null,
                district_id: null,
                zipcode: '',
                phone: ''
            },
            provinces:[],
            amphurs: [],
            districts:[],
            id: null
        }
    },
    created() {
        if(this.$route.params.id != undefined){
            this.id = this.$route.params.id
            this.$http.get('address/'+ this.id).then(response => {
                let res = response.data.data
                let address = {
                    fullname: res.fullname,
                    address:  res.address,
                    street:  res.street,
                    province_id:  res.province_id,
                    amphur_id:  res.amphur_id,
                    district_id:  res.district_id,
                    zipcode:  res.zipcode,
                    phone:  res.phone,
                }
                this.address = address
                axios.get(this.$baseURL + '/api/addresses')
                    .then(response => {
                        this.provinces = response.data
                    })
                axios.get(this.$baseURL + '/api/addresses/amphur/' + address.province_id)
                .then(response => {
                    this.amphurs = response.data
                })
                .catch(error => console.log(error))
                axios.get(this.$baseURL + '/api/addresses/district/' + address.amphur_id)
                .then(response => {
                    this.districts = response.data
                })
                .catch(error => console.log(error))
            })
        }else{
            axios.get(this.$baseURL + '/api/addresses')
            .then(response => {
                this.provinces = response.data
            })
        }
    },
    computed: {
        amphur(id){
            if(id == undefined){return null}
            return this.address.province_id
        }
    },
    watch: {
    },
    methods:{
        getAmphur(){
            let id = this.address.province_id
            this.address.amphur_id = null
            this.address.district_id = null
            axios.get(this.$baseURL + '/api/addresses/amphur/' + id)
            .then(response => {
                this.amphurs = response.data
                this.districts = []
                this.getDistrict()
            })
            .catch(error => console.log(error))
        },
        getDistrict(){
            let id = this.address.amphur_id
            this.address.district_id = null
            axios.get(this.$baseURL + '/api/addresses/district/' + id)
            .then(response => {
                this.districts = response.data
            })
            .catch(error => console.log(error))
        },
        
        updateAddress(){
            let data = this.address
            if(data.fullname == '' || data.fullname == null ){
                return
            }
            if(data.address == '' || data.address == null ){
                return
            }
            if(data.street == '' || data.street == null ){
                return
            }
            if(data.province_id == '' || data.province_id == null ){
                return
            }
            if(data.amphur_id == '' || data.amphur_id == null ){
                return
            }
            if(data.district_id == '' || data.district_id == null ){
                return
            }
            if(data.zipcode == '' || data.zipcode == null ){
                return
            }
            if(data.phone == '' || data.phone == null ){
                return
            }
            let url = ''
            if(this.id == null){
                url = 'address'
            }else{
                url = 'address/' + this.id
                data._method = 'PUT'
            }
            this.$http.post(url,data)
            .then(res => {
                this.$parent._getProfile()
                this.$router.push('/profile')
            })
            .catch(error => {
                if(!error.response){
                    return
                }
                let message = error.response.data.errors.message
                if(message != ''){
                    this.$parent.$parent.message.message = message
                    this.$parent.$parent.showMessage = !this.$parent.$parent.showMessage
                }
            })
        }
    }
}
</script>